// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tooltip_h0L5T {
  width: 100%;
}

.tooltip_container_Fk4FG {
  display: 'flex';
  padding: 8;
  flex-flow: 'column wrap';
  gap: 20;
  font-size: 16;
}

.image_WVAct {
  max-width: 100%;
  height: 250px;
  width: 444px;
  border-radius: 4px;
  background-color: var(--color-base025);
  display: flex;
  align-items: center;
  justify-content: center;
}
`, "",{"version":3,"sources":["webpack://./src/plugins/dataViewers/roomOccupancy/components/OccupancyAreaChart.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,UAAU;EACV,wBAAwB;EACxB,OAAO;EACP,aAAa;AACf;;AAEA;EACE,eAAe;EACf,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,sCAAsC;EACtC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB","sourcesContent":[".tooltip {\n  width: 100%;\n}\n\n.tooltip_container {\n  display: 'flex';\n  padding: 8;\n  flex-flow: 'column wrap';\n  gap: 20;\n  font-size: 16;\n}\n\n.image {\n  max-width: 100%;\n  height: 250px;\n  width: 444px;\n  border-radius: 4px;\n  background-color: var(--color-base025);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tooltip": `tooltip_h0L5T`,
	"tooltip_container": `tooltip_container_Fk4FG`,
	"image": `image_WVAct`
};
export default ___CSS_LOADER_EXPORT___;
